import axios from "../../axios";
import {
  GET_CHECKIN_LIST, GET_REDEMPTION_LIST, GET_PROMOTION_LIST, CHANGE_STATUS_PROMOTION, CHANGE_STATUS_REDEMPTION, PROMO_STATUS_UNDEFINED, REDEMP_STATUS_UNDEFINED, GET_CHECKOUT_INFO,
  GET_CHECKOUT_HISTORY, GET_CHECKOUT_HISTORY_SUMMARY, GET_STAFF_BY_SERVICE, CHECKOUT_SUBMIT, UPDATE_CUSTOMER_NOTE, CHECK_PHONE, CHECKIN_SUBMIT, LOGIN, UPDATE_STAFF, UPDATE_SERVICE,
  CHANGE_STATUS_SERVICE_SHOW_FULL, UPDATE_SERVICE_WITH_STAFF_AND_PRICE, UPDATE_IN_SERVICE_STATUS, CHECK_UPDATE, CHECKOUT_REDEEM, UPDATE_CUSTOMER_CHECKIN_STAFF, UPDATE_SMS_SENT
} from "./checkinTypes";
import {
  URL_GET_CHECKIN_LIST, URL_GET_CHECKOUT_HISTORY, URL_GET_STAFF_BY_SERVICE, URL_GET_CHECKOUT_HISTORY_SUMMARY, URL_GET_CHECKOUT_INFO, URL_CHECKOUT_SUBMIT,
  URL_UPDATE_CUSTOMER_NOTE, URL_CHECK_PHONE, URL_CHECKIN_SUBMIT, URL_LOGIN, URL_UPDATE_STAFF, URL_UPDATE_SERVICE, URL_UPDATE_SERVICE_WITH_STAFF_AND_PRICE,
  URL_UPDATE_IN_SERVICE_STATUS, URL_CHECK_UPDATE, URL_CHECKOUT_REDEEM, URL_UPDATE_CUSTOMER_CHECKIN_STAFF, URL_UPDATE_SMS_SENT
} from './checkinUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
export default {
  // eslint-disable-next-line
  [CHECK_PHONE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHECK_PHONE}`, data)
        .then((response) => {
          console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              // let data = resultModel.data;
              // resolve(data);
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHANGE_STATUS_SERVICE_SHOW_FULL]({ commit }, item) {
    commit(CHANGE_STATUS_SERVICE_SHOW_FULL, item);
  },

  // eslint-disable-next-line
  [UPDATE_SERVICE_WITH_STAFF_AND_PRICE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let data = new FormData();
      // for(var key in item) {
      //   data.append(key, item[key]);
      // }
      // let data = JSON.parse(JSON.stringify(item));
      // delete data.page
      // delete dat

      axios.post(`${URL_UPDATE_SERVICE_WITH_STAFF_AND_PRICE}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   page: item.page,
              //   'per-page': item['per-page']
              // }
              let temp = {};
              if(item.keyword) {
                temp.keyword = item.keyword;
              }
              if(item.type) {
                temp.type = item.type;
              }
              if(item.sort) {
                temp.sort = item.sort;
              }
              dispatch(GET_CHECKIN_LIST, temp);
              // dispatch(GET_CHECKIN_LIST);
              // dispatch(GET_CHECKOUT_INFO, {id: item.id});
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_IN_SERVICE_STATUS]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let data = new FormData();
      // for(var key in item) {
      //   data.append(key, item[key]);
      // }
      // let data = JSON.parse(JSON.stringify(item));
      // delete data.page
      // delete dat

      axios.post(`${URL_UPDATE_IN_SERVICE_STATUS}`, item)
        .then(async (response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   page: item.page,
              //   'per-page': item['per-page']
              // }
              await dispatch(GET_CHECKIN_LIST)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_SMS_SENT]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let data = new FormData();
      // for(var key in item) {
      //   data.append(key, item[key]);
      // }
      // let data = JSON.parse(JSON.stringify(item));
      // delete data.page
      // delete dat

      axios.post(`${URL_UPDATE_SMS_SENT}`, item)
        .then(async (response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   page: item.page,
              //   'per-page': item['per-page']
              // }
              await dispatch(GET_CHECKIN_LIST)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // eslint-disable-next-line
  [CHECKIN_SUBMIT]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHECKIN_SUBMIT}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_CHECKIN_LIST]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_CHECKIN_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHECKIN_LIST, data);
              resolve(data);
            } else {
              commit(GET_CHECKIN_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CHECKIN_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result != null) {
          //   commit(GET_CHECKIN_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [CHECKOUT_SUBMIT]({ dispatch, commit }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHECKOUT_SUBMIT}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(CHECKOUT_SUBMIT, data)
              let temp = {};
              if(item.keyword) {
                temp.keyword = item.keyword;
              }
              if(item.type) {
                temp.type = item.type;
              }
              if(item.sort) {
                temp.sort = item.sort;
              }
              dispatch(GET_CHECKIN_LIST, temp)
              resolve(data);
            } else {
              // console.log(resultModel.message)
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECKOUT_REDEEM]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHECKOUT_REDEEM}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // commit(CHECKOUT_REDEEM, data)
              let temp = {};
              if(item.keyword) {
                temp.keyword = item.keyword;
              }
              if(item.type) {
                temp.type = item.type;
              }
              if(item.sort) {
                temp.sort = item.sort;
              }
              dispatch(GET_CHECKIN_LIST, temp)
              resolve(data);
            } else {
              // console.log(resultModel.message)
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_STAFF_BY_SERVICE]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_STAFF_BY_SERVICE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_BY_SERVICE, data);
              resolve(data);
            } else {
              commit(GET_STAFF_BY_SERVICE, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_STAFF_BY_SERVICE, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result == null) {
          //   commit(GET_STAFF_BY_SERVICE, {items:[],_link:{},_meta:{}})
          //   resolve({items:[],_link:{},_meta:{}})
          // }else{
          //   commit(GET_STAFF_BY_SERVICE, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_PROMOTION_LIST]({ commit }, item) {
    commit(GET_PROMOTION_LIST, item)
  },

  [GET_REDEMPTION_LIST]({ commit }, item) {
    commit(GET_REDEMPTION_LIST, item)
  },

  [GET_CHECKOUT_INFO]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_CHECKOUT_INFO}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHECKOUT_INFO, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // console.log(response)
          // if(response.data.result !== null) {
          // //   commit(GET_CHECKOUT_INFO, {})
          // //   resolve({})
          // // }else{
          //   commit(GET_CHECKOUT_INFO, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CHECKOUT_HISTORY]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CHECKOUT_HISTORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHECKOUT_HISTORY, data);
              resolve(data);
            } else {
              commit(GET_CHECKOUT_HISTORY, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CHECKOUT_HISTORY, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // console.log(response.data.result.data)
          // if(response.data.result != null) {

          //   commit(GET_CHECKOUT_HISTORY, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CHECKOUT_HISTORY_SUMMARY]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CHECKOUT_HISTORY_SUMMARY}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHECKOUT_HISTORY_SUMMARY, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // console.log(response.data.result.data)
          // if(response.data.result != null) {

          //   commit(GET_CHECKOUT_HISTORY_SUMMARY, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_CUSTOMER_NOTE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_CUSTOMER_NOTE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // if(item.id) {
              // dispatch(GET_CHECKOUT_INFO, {id: item.id});
              // }
              // } else {
              let temp = {
                page: item.page ? item.page : 1,
                'per-page': item['per-page'] ? item['per-page'] : 10,
              }
              if (item.keyword) {
                temp.keyword = item.keyword;
              }
              if (item.type) {
                temp.type = item.type;
              }
              dispatch(GET_CHECKOUT_HISTORY, temp);
              // }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHANGE_STATUS_PROMOTION]({ commit }, item) {
    commit(CHANGE_STATUS_PROMOTION, item)
  },

  [CHANGE_STATUS_REDEMPTION]({ commit }, item) {
    commit(CHANGE_STATUS_REDEMPTION, item)
  },

  [PROMO_STATUS_UNDEFINED]({ commit }, item) {
    commit(PROMO_STATUS_UNDEFINED, item)
  },

  [REDEMP_STATUS_UNDEFINED]({ commit }, item) {
    commit(REDEMP_STATUS_UNDEFINED, item)
  },

  // eslint-disable-next-line
  [LOGIN]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      console.log(item)
      axios.post(`${URL_LOGIN}`, data)
        .then((response) => {
          // console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_STAFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_STAFF}`, data)
        .then((response) => {
          // console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CHECKIN_LIST)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_SERVICE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_SERVICE}`, data)
        .then((response) => {
          // console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CHECKIN_LIST)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // eslint-disable-next-line
  [UPDATE_CUSTOMER_CHECKIN_STAFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_CUSTOMER_CHECKIN_STAFF}`, data)
        .then((response) => {
          // console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_CHECKIN_LIST)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECK_UPDATE]({ commit, getters }) {
    return new Promise((resolve) => {
      axios.get(URL_CHECK_UPDATE)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (getters.lastCheckinRecord.last_checkin_active === undefined || getters.lastCheckinRecord.last_checkin_finish === undefined) {
                commit(CHECK_UPDATE, data);
              } else {
                if (getters.lastCheckinRecord.last_checkin_active == null && data.last_checkin_active != null) {
                  commit(CHECK_UPDATE, data);
                  resolve(true);
                } else if (getters.lastCheckinRecord.last_checkin_finish == null && data.last_checkin_finish != null) {
                  commit(CHECK_UPDATE, data);
                  resolve(true);
                } else if (data.last_checkin_finish != null && data.last_checkin_finish.id != getters.lastCheckinRecord.last_checkin_finish.id) {
                  commit(CHECK_UPDATE, data);
                  resolve(true);
                } else if (data.last_checkin_active != null && data.last_checkin_active.id != getters.lastCheckinRecord.last_checkin_active.id) {
                  commit(CHECK_UPDATE, data);
                  resolve(true);
                }
              }
            }
          }
        })
        .catch((error) => { console.log(error) });
    })
  },
}
